export default {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    RESOURCE_CREATED: 201,
    SERVER_ERROR: 500,
    UNAUTHORIZE: 401,

    ACCESS_TOKEN: "ACCESS_TOKEN",
};

// DEV FEATURED CHARITIES
// export const FeaturedCharities = [
//     {
//         "id": "1d2fdf46-a3e6-460b-92c4-a3eec8cd9d7d",
//         "name": "Australian Red Cross Society",
//         "alias": "",
//         "ngo_id": "43-1634280-0006778",
//         "mission": null,
//         "street1": "23-47 Villiers St",
//         "street2": "",
//         "city": "North Melbourne",
//         "region": "Victoria",
//         "postal_code": "",
//         "country": "AU",
//         "lat": "-37.7993756",
//         "lon": "144.9528867",
//         "cause": "International ",
//         "website_url": "http://www.redcross.org.au/",
//         "profile_url": "https://staging.pledge.to/organizations/43-1634280-0006778/australian-red-cross-society",
//         "logo_url": "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/stg-media/images/npos/logos/2020/1/7/f9e570da9f18598c.jpg",
//         "disbursement_type": "international_1"
//     },
//     {
//         "id": "6a70a058-cbfe-4dcb-8440-6a723a70d696",
//         "name": "MICHAEL J FOX FOUNDATION FOR PARKINSONS RESEARCH",
//         "alias": "",
//         "ngo_id": "13-4141945",
//         "mission": null,
//         "street1": "111 WEST 33RD ST 10TH FL",
//         "street2": "",
//         "city": "NEW YORK",
//         "region": "NY",
//         "postal_code": "10001-2904",
//         "country": "US",
//         "lat": null,
//         "lon": null,
//         "cause": "Medical Research",
//         "website_url": "https://www.pledgeling.com/organizations/13-4141945/michael-j-fox-foundation-for-parkinsons-research",
//         "profile_url": "https://staging.pledge.to/organizations/13-4141945/michael-j-fox-foundation-for-parkinsons-research",
//         "logo_url": "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/stg-media/images/npos/logos/default/logo.jpg",
//         "disbursement_type": "standard"
//     },
//     {
//         "id": "5bcced07-8a4a-422e-9b85-28751781a509",
//         "name": "CITY OF HOPE INTERNATIONAL",
//         "alias": "",
//         "ngo_id": "20-3997240",
//         "mission": null,
//         "street1": "5011 HOLLY DR",
//         "street2": "",
//         "city": "SAN DIEGO",
//         "region": "CA",
//         "postal_code": "92113-2047",
//         "country": "US",
//         "lat": null,
//         "lon": null,
//         "cause": "Religion",
//         "website_url": "https://www.pledgeling.com/organizations/20-3997240/city-of-hope-international",
//         "profile_url": "https://staging.pledge.to/organizations/20-3997240/city-of-hope-international",
//         "logo_url": "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/stg-media/images/npos/logos/default/logo.jpg",
//         "disbursement_type": "standard"
//     },
//     {
//         "id": "715a6153-be39-40e8-b26c-84f96dd181f0",
//         "name": "CARE USA FOUNDATION INC",
//         "alias": "",
//         "ngo_id": "80-0791500",
//         "mission": null,
//         "street1": "1006 LOXFORD TER",
//         "street2": "",
//         "city": "SILVER SPRING",
//         "region": "MD",
//         "postal_code": "20901-1127",
//         "country": "US",
//         "lat": null,
//         "lon": null,
//         "cause": "Health Care",
//         "website_url": "https://www.pledgeling.com/organizations/80-0791500/care-usa-foundation-inc",
//         "profile_url": "https://staging.pledge.to/organizations/80-0791500/care-usa-foundation-inc",
//         "logo_url": "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/stg-media/images/npos/logos/default/logo.jpg",
//         "disbursement_type": "standard"
//     }
// ];

// PROD FEATURED CHARITIES
export const FeaturedCharities = [
    {
        alias: "",
        city: "Carlton",
        country: "AU",
        disbursement_type: "international_2",
        id: "5a9fc0a1-c3ab-4cf5-b407-3a8d71481b03",
        lat: "-37.8024559",
        logo_url: "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/prod-media/images/npos/logos/2022/5/10/2bba775117fd1c11.png",
        lon: "144.9615027",
        mission: "Human dignity, peace, safety and wellbeing for all.",
        name: "Australian Red Cross Society",
        ngo_id: "30-0108263-3922",
        postal_code: "3051",
        profile_url: "https://www.pledge.to/organizations/30-0108263-3922/australian-red-cross-society",
        region: "",
        street1: "155 Pelham Street",
        street2: "",
        website_url: "http://www.redcross.org.au"
    },
    {
        alias: "The Michael J. Fox Foundation for Parkinson's Research",
        city: "TORONTO",
        country: "CA",
        disbursement_type: "standard",
        id: "969bedbb-0900-4fb6-bed7-1ec7548deb3f",
        lat: null,
        logo_url: "https://pledgeling-res.cloudinary.com/image/upload/c_fit,f_png,h_266,w_266/v1/prod-media/images/npos/logos/2023/2/23/27bd4651ec9c6581",
        lon: null,
        mission: null,
        name: "The Michael J. Fox Foundation for Parkinson's Research",
        ngo_id: "89-6568417RR0001-0065487",
        postal_code: "M5H2V1",
        profile_url: "https://www.pledge.to/organizations/89-6568417RR0001-0065487/the-michael-j-fox-foundation-for-parkinson-s-research",
        region: "ON",
        street1: "800-365 BAY STREET",
        street2: "",
        website_url: "https://www.michaeljfox.org/"
    },
    {
        alias: "",
        city: "DETROIT",
        country: "US",
        disbursement_type: "standard",
        id: "39a0f6fa-4b12-4332-9853-cff3c7095c8e",
        lat: "42.398649",
        logo_url: "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/prod-media/images/npos/logos/default/logo.jpg",
        lon: "-83.164515",
        mission: null,
        name: "CITY OF HOPE INTERNATIONAL",
        ngo_id: "38-3510219",
        postal_code: "48210-2442",
        profile_url: "https://www.pledge.to/organizations/38-3510219/city-of-hope-international",
        region: "MI",
        street1: "4600 LIVERNOIS AVE",
        street2: "",
        website_url: "https://www.pledgeling.com/organizations/38-3510219/city-of-hope-international"
    },
    {
        alias: "",
        city: "Silver Spring",
        country: "US",
        disbursement_type: "standard",
        id: "d8256c9d-a667-43b4-b381-cac87448e078",
        lat: "39.084961",
        logo_url: "https://pledgeling-res.cloudinary.com/image/upload/c_fit,h_266,w_266/v1/prod-media/images/npos/logos/default/logo.jpg",
        lon: "-77.000365",
        mission: "Care USA Foundation Inc, is a 501c(3) non-profit organization specially designed by Care Personnel Healthcare Inc, to provide free home healthcare services to wounded, ill and disabled veterans who are unable to take care of life basic needs. Our main goal is to expedite the recovery process for our brave military men and women by lifting the burdens from them and their families who have sacrificed so much for our freedom.",
        name: "Care USA Foundation",
        ngo_id: "80-0791500",
        postal_code: "20901-1127",
        profile_url: "https://www.pledge.to/organizations/80-0791500/care-usa-foundation",
        region: "MD",
        street1: "1006 Loxford Ter",
        street2: "",
        website_url: "http://cpfusa.org"
    }
];

export const KOODOS_PER_DOLLAR = 20;